export const mockSeoPages = [
  {
    id: 'seo-home',
    path: '/',
    pageName: 'Ana Sayfa',
    title: 'Zobu Consulting – Management, Policy & Engineering Consultancy | Turkey',
    description: 'Zobu Consulting provides expert management consultancy, policy development and engineering consultancy services. Trusted by leading organizations across Turkey and beyond since 2004.',
    keywords: 'management consultancy, policy development, engineering consultancy, Hakan Zobu, Turkey consulting firm',
    ogTitle: 'Zobu Consulting – Expert Consultancy Services',
    ogDescription: 'Management, Policy Development & Engineering Consultancy since 2004. Certified Management Consultants serving Turkey and global clients.',
    canonicalUrl: 'https://zobu-consulting.com/',
    lastModified: '2025-01-15',
  },
  {
    id: 'seo-services',
    path: '/services',
    pageName: 'Hizmetler',
    title: 'Consulting Services – Management, Policy & Engineering | Zobu Consulting',
    description: 'Explore Zobu Consulting\'s three core service areas: Management Consultancy, Policy Development Assistance, and Engineering Consultancy tailored to your needs.',
    keywords: 'management consultancy services, policy development Turkey, engineering consultancy, feasibility studies, competitive strategy',
    ogTitle: 'Our Consulting Services | Zobu Consulting',
    ogDescription: 'Three core pillars of expert consultancy: Management, Policy Development, and Engineering.',
    canonicalUrl: 'https://zobu-consulting.com/services',
    lastModified: '2025-01-15',
  },
  {
    id: 'seo-about',
    path: '/about',
    pageName: 'Hakkımızda',
    title: 'About Zobu Consulting – Certified Management Consultants Since 2004',
    description: 'Learn about Zobu Consulting, founded by CMC Hakan Zobu. Over 20 years of experience in management, policy and engineering consultancy across Turkey and internationally.',
    keywords: 'Hakan Zobu, certified management consultant, CMC, Zobu Consulting history, about us',
    ogTitle: 'About Zobu Consulting',
    ogDescription: 'Founded in 2004 by Hakan Zobu, a Certified Management Consultant with global expertise.',
    canonicalUrl: 'https://zobu-consulting.com/about',
    lastModified: '2025-01-15',
  },
  {
    id: 'seo-contact',
    path: '/contact',
    pageName: 'İletişim',
    title: 'Contact Zobu Consulting – Get Expert Consultancy Advice',
    description: 'Contact Zobu Consulting for professional management, policy development or engineering consultancy services. Based in Turkey, serving clients worldwide.',
    keywords: 'contact Zobu Consulting, consultancy inquiry, Hakan Zobu contact, Turkey consultant',
    ogTitle: 'Contact Us | Zobu Consulting',
    ogDescription: 'Reach out to our team of expert consultants for a free initial consultation.',
    canonicalUrl: 'https://zobu-consulting.com/contact',
    lastModified: '2025-01-15',
  },
  {
    id: 'seo-ethics',
    path: '/code-of-ethics',
    pageName: 'Etik Kurallar',
    title: 'Code of Ethics – Professional Standards | Zobu Consulting',
    description: 'Zobu Consulting operates under a strict code of ethics aligned with international management consulting standards. Transparency, integrity, and client commitment.',
    keywords: 'code of ethics, consulting standards, CMC ethics, professional conduct, Zobu Consulting values',
    ogTitle: 'Code of Ethics | Zobu Consulting',
    ogDescription: 'Our professional ethics framework and commitment to integrity in consulting.',
    canonicalUrl: 'https://zobu-consulting.com/code-of-ethics',
    lastModified: '2025-01-15',
  },
];